import { render } from "./ProvidersTree.vue?vue&type=template&id=0da8eae2"
import script from "./ProvidersTree.vue?vue&type=script&lang=js"
export * from "./ProvidersTree.vue?vue&type=script&lang=js"

import "./ProvidersTree.vue?vue&type=style&index=0&id=0da8eae2&lang=css"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__